// extracted by mini-css-extract-plugin
export var avatar = "_on-3";
export var avatarContainer = "_on-2";
export var avatarSpacer = "_on-5";
export var avatarSpacerContainer = "_on-4";
export var avatarStackContainer = "_on-1";
export var bubble = "_on-0";
export var remainderBubble = "_on-6";